import { render, staticRenderFns } from "./RelanceDeces.vue?vue&type=template&id=8dcf7164"
import script from "./RelanceDeces.vue?vue&type=script&lang=js"
export * from "./RelanceDeces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports